export default {
  computed: {
    mobileAccountMenu() {
      return this.$store.getters.MOBILE_ACCOUNT_MENU;
    },
  },
  watch: {
    mobileAccountMenu(val) {
      this.$emit('handle-account-menu', val);
    }
  },
  methods: {
    isActiveRoute(path) {
      return this.currentRoutePath.replace(/\/$/, '') === path;
    },
    goTo(path) {
      this.$store.dispatch('SET_MOBILE_ACCOUNT_MENU', false);

      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }
    },
    logoutHandler() {
      this.$store.dispatch('SET_MOBILE_ACCOUNT_MENU', false);
      this.logout();
    }
  },
};
